import "prismjs";
import "./prism-clike";
import "prismjs/components/prism-sqf";
